import React from 'react';

export default function LayoutAppLoading(props) {

    const onTopOverlayClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div className="ui-view-loading view-loading" onClick={onTopOverlayClick}>
            <div className="gd-loading main-area">
                <img src={gdConfig.assetsPath+"/skin/common/loader/app-loading.gif?43"} />
                <p>Loading ...</p>
            </div>
        </div>
    );
}